// shared/src/schemas/brief-payload-row.ts
// Zod schema for `brief_payloads` table (DDL: 0001_init.sql:43-57). 5 cols.
// Adds the missing Zod guard called out by audit-r3 S-002.
//
// NOTE: `kind` is intentionally a free-form z.string() — per the DDL comment
// at 0001_init.sql:46-52, the SQL CHECK was deliberately omitted to honor
// §3.3.1 #4 ("brief_payloads.kind is the schema extension point — new kinds
// need no migration"). The discriminated-union producer enum lives in
// shared/src/types/brief-payload.ts (BriefPayloadKind) and is enforced at
// app boundaries, not at the DB row level. This schema mirrors that decision
// rather than re-imposing a frozen enum here.

import { z } from 'zod';

export const BriefPayloadRowSchema = z.object({
  id:          z.string(),
  brief_id:    z.string(),
  kind:        z.string(),    // discriminated-union enum lives in types/brief-payload.ts
  payload:     z.string(),    // JSON-encoded; shape per kind
  created_at:  z.string().datetime(),
});

export type BriefPayloadRow = z.infer<typeof BriefPayloadRowSchema>;
